import {useState} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";


export default function ReelsFilterIsActive(props) {
    //console.debug("RTS Break ReelsFilterIsActivate");

    const [isActive, setIsActive] = useState(props.isActive==null?1:props.isActive);
    const [repoIsActive] = useState([{value:-1, label:"All"}, {value:0, label:"Not Activated"}, {value:1, label:"Activated"}]);


    function valChange(e, val){
        setIsActive(val.value);
        props.setIsActiveFx(val.value);
        props.setFormDirtyFx(1);
    }

 
    return(
        <>
            <Autocomplete
                options={repoIsActive}
                renderInput={(params) => <TextField {...params} label="Activated"  size="small" />}
                value={repoIsActive.find(v => v.value===isActive)}
                onChange={valChange}
                getOptionLabel={(repoIsActive) => repoIsActive.label}
                disableClearable={true}
                renderOption={(props, repoIsActive) => (
                    <Box component="li" {...props} key={repoIsActive.value}>
                        {repoIsActive.label}
                    </Box>
                )}
            />
        </>
    );
}
